<!-- SKU转箱指令管理 -->
<template>
	<div 
	:lang="$i18n.locale"
	class>
		<div class="listHeader">
			<i></i><span>{{$t('commonInfo.commandList')}}</span>
		</div>
		<el-form :model="queryParams" ref="queryForm" :inline="true" label-width="auto" style="margin:10px 0 0 20px">
			<el-form-item label>
				<el-input v-model="queryParams.orderNo" :placeholder="$t('tipsInfo.inputPlaceholder') + '订单号'" type="text" clearable />
			</el-form-item>
			<el-form-item label>
				<el-input v-model="queryParams.commandNo" :placeholder="$t('tipsInfo.inputPlaceholder') + '指令单号'" type="text" clearable />
			</el-form-item>
			<el-form-item label>
				<el-select v-model="queryParams.commandStatus" :placeholder="$t('tipsInfo.selectPlaceholder') + '状态'" clearable>	
					<el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-search" @click="handleQuery">{{$t('commonInfo.searchBtn')}}</el-button>
				<el-button icon="el-icon-refresh" @click="handleRefresh">{{$t('commonInfo.refreshBtn')}}</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="handleCreateCmd()">{{$t('commonInfo.createBtn')}}</el-button>
			</el-form-item>
		</el-form>

		<!-- 展示 -->
		<el-table style="margin:0 15px;width: calc(100% - 30px)" v-loading="loading" :data="dataList" border>
			<el-table-column label="指令单号" align="center" prop="commandNo" min-width="180" />
			<el-table-column label="订单号" align="center" prop="orderNo" min-width="180" />
			<el-table-column label="SKU总数" align="center" prop="skuCount" min-width="100" />
			<el-table-column label="转换箱数" align="center" prop="actualPackingCount" min-width="100">
				<template slot-scope="scope">
					<!-- 当状态为完成指令才显示箱数 -->
					{{scope.row.commandStatus == 800 ? scope.row.actualPackingCount : ''}}	
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center" prop="commandStatus" min-width="120">
				<template slot-scope="scope">
					<el-tag :type="returnStatusName(scope.row.commandStatus,'2')">{{returnStatusName(scope.row.commandStatus,'1')}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="创建时间" align="center" prop="createTime" min-width="160" />
			<el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right" width="120px">
				<template slot-scope="{ row }">
					<el-button size="mini" type="text" icon="el-icon-view" @click="handleViewProduct(row)">{{$t('commonInfo.actionCheckProduct')}}</el-button>
				    <br />
					<el-button v-if="row.commandStatus == 800" size="mini" type="text" icon="el-icon-view" @click="handleViewCarton(row)">查看箱</el-button>
				    <br v-if="row.commandStatus == 800" />
					<el-button v-if="row.commandStatus == 100" size="mini" type="text" icon="el-icon-delete" @click="handleCancelCmd(row)">{{$t('commonInfo.dialogBtnCancel')}}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<div class="pageBottom">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[10, 20, 30, 40]" :page-size="queryParams.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
		
		<!-- 查看商品详情 -->
		<CheckProduct :visible.sync="productPopup" :rowData="rowData" />
		<!-- 创建指令 -->
		<CreateCommand :visible.sync="createPopup" />
		<!-- 查看箱信息 -->
		<CheckCartonList :visible.sync="cartonPopup" :orderId="currentOrderId" />
	</div>
</template>

<script>
	import CheckProduct from './checkProduct';
    import CreateCommand from './createCommand';
    import CheckCartonList from './checkCartonList';
	export default {
		components: {
			CheckProduct,
			CreateCommand,
			CheckCartonList
		},
		data() {
			return {
				queryParams: {
					page: 1,
					limit: 10,
					commandNo: '',
					commandStatus: '',
					operationType:'10',// 指令类型，默认sku转整箱 10
					orderNo: '',
				},
				loading: false,
				total: 0,
				dataList: [],
				statusList: [
					{ value: 100, label: '待处理' },
					{ value: 310, label: '分拣中' },
					{ value: 320, label: '打包中' },
					{ value: 800, label: '已完成' },
					{ value: -800, label: '已取消' },
				],
				// 查看商品详情
				productPopup: false,
				rowData: {},
				// 创建指令
			    createPopup: false,
			    // 查看箱信息
			    cartonPopup: false,
			    currentOrderId: ''
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			// 分页条数
			handleSizeChange(size) {
				this.queryParams.limit = size;
				this.queryParams.page = 1;
				this.getList();
			},
			// 分页页数
			handleCurrentChange(page) {
				this.queryParams.page = page;
				this.getList();
			},
			// 根据状态码显示信息
			returnStatusName(status,type) {
				let name = '',btnType = '';
				switch(status) {
					case 100: name = '待处理'; btnType = 'info'; break;
					case 310: name = '分拣中'; btnType = 'warning'; break;
					case 320: name = '打包中'; btnType = 'warning'; break;
					case 800: name = '已完成'; btnType = 'success'; break;
					case -800: name = '已取消'; btnType = 'danger'; break;
					default: name = status; break;
				}
				return type == '1' ? name : btnType
			},
			async getList() {
				this.loading = true;
				this.dataList = [];
				// 调用接口获取指令列表
				const res = await this.$http.post('/toborder/owh/operationCommand/page', this.queryParams);
				if (res.code === 200) {
					this.dataList = res.data.list;
					this.total = res.data.totalCount;
					this.loading = false;
				} else {
					this.$message.error(res.msg || '获取指令列表失败');
					this.loading = false;
				}
			},
			handleQuery() {
				this.queryParams.page = 1;
				this.getList();
			},
			handleRefresh() {
				this.queryParams = {
					page: 1,
					limit: 10,
					commandNo: '',
					commandStatus: '',
					operationType:'10',// 指令类型，默认sku转整箱 10
					orderNo: '',
				};
				this.getList();
			},
			handleCreateCmd() {
				// 打开创建指令对话框
				this.createPopup = true;
			},
			handleViewProduct(row) {
				// 打开商品详情窗口
				this.rowData = row;
				this.productPopup = true;
			},
			handleCancelCmd(row) {
			// 取消指令
			this.$confirm('确定要取消该指令吗？', '警告', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.get('toborder/owh/operationCommand/cancel/' + row.id).then(res => {
					if (res.code === 200) {
						this.$message.success('取消成功');
						this.getList();
					} else {
						this.$message.error(res.msg || '取消指令失败');
					}
				})
			}).catch(() => {
				this.$message.info('已取消取消指令');
			});
		},
		handleViewCarton(row) {
			// 打开箱信息窗口
			this.currentOrderId = row.orderNo;
			this.cartonPopup = true;
		},
	},
}
</script>

<style scoped>
	.listHeader {
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 22px;
	}

	.listHeader i {
		width: 4px;
		height: 40px;
		display: inline-block;
		background-color: #0077AA;
		float: left;
		margin: 5px 10px;
	}

	.listHeader span {
		display: inline-block;
		float: left;
	}
	.pageBottom {
		margin: 20px;
		text-align: right;
	}
</style>